(() => {
  const dialog = document.getElementById('jr-size-guide');
  if (!dialog) return;
  let trigger;
  let previousOverflow;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-jr-size-guide]');
    if (button) {
      event.preventDefault();
      if (dialog.open) return;
      trigger = button;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-jr-size-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    if (trigger?.isConnected) trigger.focus();
  });
})();
